import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Container = styled.div`
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const RadioInputContainer = styled.div`
  padding: ${({ theme }) =>
    `${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(3.5)}`};
`;

export const OptionPremiumLabel = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
  display: inline-block;

  margin-left: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => `0 ${theme.spacing(2)}`};

  background: ${({ theme }) => theme.palette.info.light};
  border-radius: ${({ theme }) => theme.spacing(6)};

  color: ${({ theme }) => theme.palette.info.main};
`;
